export default __webpack_public_path__ + "static/media/nearkat-logo.14d0b03a.svg";